import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Button from "../MDButton";
import { actions } from "../../store/reducers/main";

function NotFound() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.setIdentifier("not-found", undefined));
  }, []);

  return (
    <div className="not-found-container">
      <Card className="not-found-card">
        <img alt="12" src="/assets/images/not-found.png" />
        <Link to="/">
          <Button size="lg" background="light-blue" color="white">
            Take me back
          </Button>
        </Link>
      </Card>
    </div>
  );
}

export default NotFound;
